import { getErpModules } from "src/admin/modules.ts";
import type { Module } from "src/system/module.types.ts";

export const getModules = (): Module[] => getErpModules();
